import moment from 'moment-timezone'

export default {
    getDateTimeInET (dateString) {
        if (dateString) {
            return moment(dateString).tz('America/New_York').format('YYYY-MM-DD HH:mm')
        } else {
            return ''
        }
    },
    getETDateString (date) {
        return this.getDateTimeInET(date).substr(0, 10)
    },
    getETTimeString (date) {
        return this.getDateTimeInET(date).substr(11, 5)
    },
    getUTCTimestamp (dateString, timeString) {
        if (moment(dateString + ' ' + timeString).isValid()) {
            const estDate = moment.tz(dateString + ' ' + timeString, 'America/New_York')
            const utcDate = estDate.clone().tz('UTC')
            return new Date(utcDate.format()).getTime()
        } else {
            return null
        }
    },
    dateETDateWeekAgoString () {
        const date = new Date()
        date.setDate(new Date().getDate() - 7)

        return this.getETDateString(date)
    },
}
